(function() {
  angular
    .module('cfn')
    .factory('CropPlanningDataResolver', CropPlanningDataResolver);

  CropPlanningDataResolver.$inject = ['$log', '$route', 'CropPlanningData'];

  function CropPlanningDataResolver($log, $route, CropPlanningData) {
    return function() {
      var data;
      // Decide if a crop planning scenario or a crop overview should be shown
      if ($route.current.params.cropoverviewyear) {
        data = CropPlanningData.CropOverview.get(
          { year: $route.current.params.cropoverviewyear },
          function() {
            filterInvalidFields(data);
            app.farmnetControllers.data = data;
          }
        );
      } else {
        $log.error('Neither scenario ID nor crop overview year given');
      }

      return data.$promise;

      function filterInvalidFields(operationData) {
        var cropData = operationData.details;

        operationData.details = cropData.filter(function(item) {
          return item.field.invalid === false;
        });
      }
    };
  }
})();
